module.exports = __webpack_public_path__ + "img/speaker.81b747e6.png";